import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact';
import Button from 'react-bootstrap-button-loader';
import SucursalForm from './SucursalForm';
import Loader from '../common/loaderapp';

const Sucursales = () => {
    const [vistaFormulario, setVistaFormulario] = useState(false);
    const [sucursalAEditar, setSucursalAEditar] = useState(null);
    const [datos, setDatos] = useState([]);
    const [loading, setLoading] = useState(true);

    const cargarSucursales = async () => {
        try {
            setLoading(true);
            const response = await fetch('/p_sucursales', {
                headers: { 'Content-Type': 'application/json' }
            });
            const payload = await response.json();
            setDatos(Array.isArray(payload) ? payload : []);
        } catch (error) {
            console.log('Error:', error);
            setDatos([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarSucursales();
    }, []);

    const cabecera = [
        { Header: <b>Nombre de sucursal</b>, accessor: 'nombre', show: true },
        { Header: <b>Dirección</b>, accessor: 'direccion', show: true },
        { Header: <b>Longitud</b>, accessor: 'longitud', show: true },
        { Header: <b>Latitud</b>, accessor: 'latitud', show: true },
        { Header: <b>Horario</b>, accessor: 'horario', show: true },
        { Header: <b>Estatus</b>, accessor: 'estatus', show: true }
    ];

    const toggleAgregar = () => {
        setSucursalAEditar(null);
        setVistaFormulario(true);
    };

    const detalle_dato = (dato) => {
        setSucursalAEditar(dato);
        setVistaFormulario(true); 
    };

    const guardarSucursal = async (nuevaData) => {
        const esEdicion = Boolean(sucursalAEditar && sucursalAEditar.id);
        const payload = {
            ...nuevaData,
            id: esEdicion ? sucursalAEditar.id : undefined
        };

        const response = await fetch('/p_sucursales', {
            method: esEdicion ? 'PUT' : 'POST',
            body: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' }
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || result?.status === 'ERROR') {
            throw new Error(result?.mensaje || 'No se pudo guardar la sucursal');
        }

        await cargarSucursales();
        setVistaFormulario(false);
        setSucursalAEditar(null);
    };

    const eliminarSucursal = async (dato) => {
        const response = await fetch('/p_sucursales', {
            method: 'DELETE',
            body: JSON.stringify({ id: dato.id }),
            headers: { 'Content-Type': 'application/json' }
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || result?.status === 'ERROR') {
            throw new Error(result?.mensaje || 'No se pudo eliminar la sucursal');
        }

        await cargarSucursales();
        setVistaFormulario(false);
        setSucursalAEditar(null);
    };


    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Sucursales" />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        {vistaFormulario ? (
                            <SucursalForm 
                                datoEditar={sucursalAEditar} 
                                alGuardar={guardarSucursal} 
                                alCancelar={() => setVistaFormulario(false)}
                                alEliminar={eliminarSucursal} 
                            />
                        ) : (
                            <div className="card">
                                <div className="d-flex justify-content-between align-items-center card-header" style={{ paddingRight: 38, paddingTop: 15, paddingBottom: 15}}>
                                    <h5>Lista de Sucursales</h5>
                                    <Button className="btn btn-primary" onClick={toggleAgregar}>
                                        Agregar sucursal <i class="icofont-ui-add" style={{ paddingLeft: 5 }}></i>
                                    </Button>
                                </div>
                                <div className="card-body datatable-react text-center">
                                    {loading ? (
                                        <Loader />
                                    ) : (
                                        <Tablereact
                                            myData={datos}
                                            cabecera={cabecera}
                                            pageSize={20}
                                            paginacion={true}
                                            buscador="Buscar sucursal"
                                            detalle={detalle_dato}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Sucursales;